<div class="chase-upload-container">

  <div class="container-back-button">
    <app-back-button [text]="backButtonText"></app-back-button>
  </div>

  <h3 class="container-header">
    CHASE UPLOAD
  </h3>

  <div class="chase-header bold">CHASES AT THIS ADDRESS</div>

  <app-server-grid
    [configuration]="chaseGridConfiguration"
    [(request)]="request"
    [refresh]="refreshGrid"
    [isLoadOnInit]="true"
    [(selection)]="chaseGridSelection"
    (selectionChange)="displayDocumentList($event)"
    [actionTemplate]="chaseGridactionTemplate"
    [views]="views"
    [refreshViews]="refreshViews"
    [displayCheckedItemsInGridView]="true"
    [filterTemplate]="filterForm"
    filterHeaderText="Chase Query">

    <ng-template #chaseGridactionTemplate let-i="index" let-rowData let-localActionPopover="actionPopover">
      <pre>Index: {{ i }}</pre>
      <pre>JSON: {{ rowData | json }}</pre>
      <app-button text="Print To Console" (onClick)="printActionArgumentsToConsole(i, rowData); localActionPopover.hide();"></app-button>
    </ng-template>

    <ng-template #filterForm let-form>
      <form [formGroup]="form" class="ui-modal-width" #chaseForm="ngForm">
        <app-tab-menu orientation="left">
          
          <app-tab-panel header="Assigned To">
            <div class="p-col-12 p-md-12 p-lg-12">
              <form-factory [formGroup]="form" [model]="assignedToInput"></form-factory>
            </div>
          </app-tab-panel>

          <app-tab-panel class="checkbox-group" header="Pend Codes">
            <div class="p-col-12 p-md-12 p-lg-12">
              <form-factory [formGroup]="form" [model]="pendCode"></form-factory>
            </div>
          </app-tab-panel>

          <app-tab-panel class="checkbox-group__halves" header="Pend Status">
            <div class="p-col-12 p-md-12 p-lg-12">
              <form-factory [formGroup]="form" [model]="pendStatus"></form-factory>
            </div>
          </app-tab-panel>
          
          <app-tab-panel class="checkbox-group__halves" header="Project(s)" selected="true">
            <div class="p-col-12 p-md-12 p-lg-12">
              <form-factory [formGroup]="form" [model]="projectsInput"></form-factory>
            </div>
          </app-tab-panel>

          <app-tab-panel class="checkbox-group__fourths" header="Measures">
            <div class="p-col-12 p-md-12 p-lg-12">
              <form-factory [formGroup]="form" [model]="measuresInput"></form-factory>
            </div>
          </app-tab-panel>

          <app-tab-panel header="Tags">
            <label class="tag-label">Tags</label>
            <div class="tag__filterform">
              <div class="p-grid p-col-12 p-md-12 p-lg-12">
                <div class="p-col-2 p-md-2 p-lg-2">
                  <form-factory class="tag__operatorform" [formGroup]="form" [model]="tagsSearchOperatorInput"
                    (onChange)="getSearchOperatorValue($event)">
                  </form-factory>
                </div>
                <div class="p-col-10 p-md-10 p-lg-10">
                  <app-button *ngIf="overlayPanelVisible && isShowCloseIcon"
                    class="tag-content__item tag-content__item--multitag-close-icon" classes="transparent small"
                    icon="times-circle" (onClick)="resetTagSearchInput()">
                  </app-button>
                  <form-factory class="tag__panelform" [formGroup]="form" [model]="tagsInput"
                    (onPanelShow)="onShowEvent(true)" (onPanelHide)="onShowEvent(false)" (keyup)="onKeyUp($event)">
                  </form-factory>
                </div>
              </div>
            </div>
          </app-tab-panel>
        </app-tab-menu>
      </form>
    </ng-template>

  </app-server-grid>

  <div
    class="required-documents-container header bold"
    [ngClass]="isdisplay ? 'show-document-list':'hide-document-list'">

    <form [formGroup]="requiredDocumentsForm">
      <div class="required-doc-title">
        <h3>REQUIRED DOCUMENTS</h3>
        <div class="selectAll-button">
          <div class="buttons">
            <p-selectButton
              [options]="selectAllButtonOptions"
              formControlName="isSelectAll"
              (onChange)="selectAllButtons($event)"
              [(ngModel)]="selectedAllButton"></p-selectButton>
            <app-button text="CLEAR" (onClick)="clearAllButton()"></app-button>
          </div>
        </div>
      </div>
      <div class="required-docs-container">
        <div
          class="required-doc"
          *ngFor="let item of requiredDocumentsForm.get('RequiredDoc')['controls'] let i=index; trackBy: trackByIndex"
          [formGroup]="item">
            <div class="buttons">
              <p-selectButton
                [options]="requirementsOptions"
                formControlName="isUploaded"
                (onChange)="checkButtonStatus()"
                [(ngModel)]="selectedButton"></p-selectButton>
            </div>
            <div class="description">{{item.get('documentName').value}}</div>
          </div>
          <div class="description dates-of-service">
            <div *ngIf="datesOfService?.length; else noDates">
              <b><u>Dates of service ({{datesOfService?.length}})</u></b>
              <p *ngFor="let date of datesOfService; let i = index; trackBy: trackByIndex">
                {{ date }}
              </p>
            </div>
            <ng-template #noDates>
              <p>No Dates of Service available for chase</p>
            </ng-template>
          </div>
      </div>
    </form>

    <div class="upload-button-container">
      <div class="bottom-left-container">
        <app-upload-message></app-upload-message>
        <app-file-upload #fileUpload
          chooseLabel="Upload"
          [data]="uploadData"
          [disabled]="!documentSelected"
          (onUpload)="uploadDocument($event)"></app-file-upload>
      </div>
        
      <div class="bottom-right-container">
        <app-button class="header-button"
                    text="Pend This Chase"
                    [disabled]="!pendSelected"
                    (onClick)="createPend()"></app-button>
      </div>
      <app-pend-modal [(visible)]="isPendModalVisible"
                      (onHide)="closePendModal()"
                      [(chases)]="selectedChases"></app-pend-modal>
    </div>

  </div>

</div>
